import React, { useState } from "react";
import "../../styles/dash/NavDashBoard.css";
import { useNavigate } from "react-router-dom";

interface NavDashProps {
  title: React.ReactNode; 
}

const NavDash: React.FC<NavDashProps> = ({ title }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  // NUEVA FUNCIÓN para manejar la navegación al perfil
  const handleProfileClick = () => {
    navigate("/dashboard/profile");
    setMenuOpen(false); // Cierra el menú después de navegar
  };

  return (
    <div className="nav-dash-container elementor-sticky">
      <div className="nav-dash-inner">
        <div className="nav-dash-title">
          <h1>{title}</h1>
        </div>

        <div className="nav-dash-menu-wrapper">
          <button className="nav-dash-menu-toggle" onClick={toggleMenu}>
            &#9776;
          </button>

          {menuOpen && (
            <div className="nav-dash-dropdown">
              
              {/* Botón "Perfil" con la nueva función onClick */}
              <button className="nav-dash-item-anchor" onClick={handleProfileClick}>
                Perfil
              </button>

              <button className="nav-dash-item-anchor" onClick={handleLogout}>
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavDash;